import React, { useContext } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import { UserContext } from 'commons-ui';

import usePermission from './usePermission';

interface IAuthorizedRouteProps {
	path: any;
	component: any;
	configPageName: string;
	configResourceName?: string;
	configActionName?: string;
	exact?: boolean;
}

const AuthorizedRoute: React.FC<IAuthorizedRouteProps> = ({
	path,
	component,
	exact,
	configPageName,
	configResourceName,
	configActionName
}) => {
	const { isLoggedIn, user } = useContext(UserContext);
	const { hasPermission } = usePermission();

	const history = useHistory();
	// If logged in
	if (!isLoggedIn || _isEmpty(user)) {
		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { referrer: history.location.pathname }
				}}
			/>
		);
	}

	// checking for permission
	if (!hasPermission({ configPageName, configResourceName, configActionName })) {
		return (
			<Redirect
				to={{
					pathname: '/error',
					state: { statusCode: 403, errorMsg: 'You are not authorized to perform this action' }
				}}
			/>
		);
	}
	return <Route exact={exact} path={path} component={component} />;
};

export default AuthorizedRoute;
